var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPack3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28.348pt",
    height: "10.953pt",
    viewBox: "0 0 28.348 10.953",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.4375-5.2656h-1.6719v5.2656h0.59375v-2.1875h1.0781c1.1875 0 1.8281-0.54688 1.8281-1.5469 0-0.98438-0.64062-1.5312-1.8281-1.5312zm-1.0781 2.5938v-2.1094h1.0469c0.82812 0 1.2344 0.29688 1.2344 1.0469 0 0.76562-0.40625 1.0625-1.2344 1.0625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7031-3.6406c-0.48438 0-0.875 0.10938-1.1094 0.20312v0.51562h0.015625c0.1875-0.09375 0.5625-0.25 0.98438-0.25 0.78125 0 1 0.375 1 1v0.32812c-0.21875-0.09375-0.59375-0.20312-1.0156-0.20312-0.84375 0-1.2344 0.4375-1.2344 1.0625 0 0.64062 0.4375 1.0312 1.0781 1.0312 0.625 0 1-0.29688 1.1719-0.5v0.45312h0.57812v-2.2188c0-0.89062-0.4375-1.4219-1.4688-1.4219zm0.89062 2.7969c-0.14062 0.21875-0.45312 0.48438-0.95312 0.48438-0.51562 0-0.73438-0.28125-0.73438-0.64062 0-0.40625 0.25-0.70312 0.82812-0.70312 0.32812 0 0.65625 0.10938 0.85938 0.20312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.375-1.7969c0 1.0781 0.67188 1.8438 1.7656 1.8438 0.4375 0 0.78125-0.14062 0.9375-0.23438v-0.5625h-0.03125c-0.15625 0.14062-0.46875 0.29688-0.89062 0.29688-0.64062 0-1.2031-0.42188-1.2031-1.3438s0.5625-1.3438 1.2031-1.3438c0.42188 0 0.73438 0.15625 0.89062 0.28125h0.03125v-0.54688c-0.15625-0.10938-0.5-0.23438-0.9375-0.23438-1.0938 0-1.7656 0.76562-1.7656 1.8438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.3906-2.2188 0.54688-0.57812 0.70312-0.78125v-0.015625h-0.67188l-0.015625 0.015625s-0.3125 0.35938-0.53125 0.60938l-1.1719 1.3594v-3.6562h-0.57812v5.2656h0.57812v-0.95312l0.76562-0.85938 0.76562 1.2969 0.29688 0.5 0.015625 0.015625h0.65625v-0.03125l-0.39062-0.625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.4531-2.7188c0.51562-0.10938 0.90625-0.54688 0.90625-1.2031 0-0.82812-0.59375-1.4062-1.6406-1.4062-0.64062 0-1.1094 0.20312-1.3125 0.35938v0.59375h0.015625c0.125-0.10938 0.54688-0.4375 1.2031-0.4375 0.6875 0 1.125 0.32812 1.125 0.92188 0 0.53125-0.28125 0.95312-1.2344 0.95312-0.3125 0-0.78125-0.015625-0.78125-0.015625h-0.015625v0.5h0.79688c0.95312 0 1.3438 0.35938 1.3438 1 0 0.59375-0.40625 1.0312-1.2656 1.0312-0.60938 0-1.0469-0.1875-1.25-0.34375h-0.03125v0.57812c0.23438 0.125 0.70312 0.28125 1.2969 0.28125 1.1406 0 1.8594-0.625 1.8594-1.5312 0-0.75-0.48438-1.1562-1.0156-1.2656z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m22.867 10.953h-17.391c-3.0234 0-5.4766-2.4531-5.4766-5.4766 0-3.0273 2.4531-5.4766 5.4766-5.4766h17.391c3.0273 0 5.4805 2.4492 5.4805 5.4766 0 3.0234-2.4531 5.4766-5.4805 5.4766",
    fill: "#dedacf"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-822.26 -426.69)",
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("use", {
    x: 826.18103,
    y: 434.52899,
    xlinkHref: "#glyph-0-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 830.42633,
    y: 434.52899,
    xlinkHref: "#glyph-0-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 834.21338,
    y: 434.52899,
    xlinkHref: "#glyph-0-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 837.65479,
    y: 434.52899,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 841.24658,
    y: 434.52899,
    xlinkHref: "#glyph-0-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 842.83203,
    y: 434.52899,
    xlinkHref: "#glyph-0-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m524.2 69.25v-0.0977h-906.99v-127.36h906.89v127.46h0.1015v-0.0977 0.0977h0.098v-127.66h-907.29v127.76h907.29v-0.10156",
    fill: "#ed1c24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPack3);
export default __webpack_public_path__ + "static/media/pack3.800e878312a1ac38e76d1fe5538daefc.svg";
export { ForwardRef as ReactComponent };